import s from "./vendorBadge.module.css";
import {ritaIcon} from "../../../assets";
import {useUserContext} from "../../../contexts";
import {withErrorBoundary} from "../../ErrorBoundary";

const VendorBadge = (props) => {
    // Destructured props
    let {
        tier = "none",
        description = "",
        tierData = {}
    } = props;

    // Retrieves the flag to control the affiliation data customizations
    const [{}, {}, {}, generalData] = useUserContext();
    const {affiliationData} = generalData;

    // Formats the tier label to lowercase text
    // (the tier may arrive null from the order payload, hence the type check)
    tier = typeof tier === "string" ? tier.toLowerCase() : "none";

    // Extra validation layer
    tier = tier.includes("tabela") ?
        tier.split("-").slice(-1)[0] :
        tier;

    // Bridge for the standard table subscription tier
    tier = tier === "padrão" ? "padrao" : tier;

    // Some fallback stuff
    // (not to be 100% reliable, but it should work in some corner cases)
    const TIERS = {
        assinante: {
            color: "#9146FF",
            label: "Tabela Assinante"
        },
        padrao: {
            color: "#706BFF",
            label: "Tabela Padrão"
        },
        especial: {
            color: "#FF815E",
            label: "Tabela Especial"
        }
    }

    // The table data comes straight from the group price payload, so it may be
    // null, a list (endpoints that don't filter by tier) or carry a null label
    // (customer group registered without one) — none of which is renderable.
    const tableData = (tierData && !Array.isArray(tierData)) ? tierData : {};
    const tableLabel = typeof tableData.label === "string" ? tableData.label : "";

    const isRitaMember = affiliationData?.vendor === "RITA";

    // The label either travels with the table or falls back to the static map
    const label = tableLabel || TIERS[tier]?.label || "";

    // Validation for when the user is not a Rita member.
    // And also prevents component from rendering
    // if the given tier isn't included in the object,
    // or if there is no label to show at all.
    if (
        !label ||
        (
            isRitaMember &&
            Object.keys(TIERS).indexOf(tier) < 0 &&
            (
                !tableLabel ||
                !tableData.tableCode
            )
        ) ||
        (
            !isRitaMember &&
            Object.keys(tableData).length === 0
        ) ||
        label.toLowerCase().includes("geral")
    ) {
        return null;
    }

    const descriptionLabel =
        affiliationData?.vendor !== "RITA" ? null : (
            <p className={`text-white text-[12px] leading-none`}>
                {description}
            </p>
        );

    const iconSrc =
        affiliationData?.customizations?.icon ?
            `/media/${affiliationData?.customizations?.icon}` :
            ritaIcon;

    return (
        <div
            className={`${s.root} dark:!bg-contrast-yellow`}
            style={{
                backgroundColor: tableData.color || TIERS[tier]?.color
            }}
        >
            <img
                src={iconSrc}
                className={s.icon}
                alt="Rita logo"
            />
            <div className={`flex flex-col gap-y-0.5`}>
                <p className={`${s.label}`}>
                    {label}
                </p>
                {descriptionLabel}
            </div>
        </div>
    )
}

// Decorative badge: a render crash here must never take the page down
// (PEC-679) — degrade silently, the product renders without the badge.
export default withErrorBoundary(VendorBadge, {scope: "vendor-badge", fallback: null});
